import { useState } from "react";
import { toast } from "sonner";
import { Archive } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useServices } from "@/context/ServicesContext";
import { DayDialog } from "@/components/app/DayDialog";

export const ArchiveButton = ({ s }) => {
  const { bump } = useServices();
  const [state, setState] = useState(null);
  const open = (e) => {
    e.stopPropagation();
    setState({
      title: "Arquivar sem retorno", submitLabel: "Arquivar", noteLabel: "Anotação",
      description: `${s.client_name} · ${s.service_name || ""}. Sai do calendário e do planejamento e vai para a aba Arquivados.`,
      onSubmit: async ({ note }) => { await api.post(`/services/${s.id}/archive`, { note }); toast.success(`${s.client_name} arquivado.`); bump(); },
    });
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={open} className="h-8 rounded-full border-slate-600 bg-transparent px-3 text-xs text-slate-200" data-testid={`archive-button-${s.id}`}>
        <Archive className="mr-1 h-3.5 w-3.5" /> Arquivar
      </Button>
      <DayDialog state={state} onClose={() => setState(null)} />
    </>
  );
};
